import script from "./AllTab.vue?vue&type=script&setup=true&lang=js"
export * from "./AllTab.vue?vue&type=script&setup=true&lang=js"

import "./AllTab.vue?vue&type=style&index=0&id=7aa9dd3d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7aa9dd3d"]])

export default __exports__